import { imageDropzonesInit } from "./imageDropzones";
import type { RecDropzoneFiles, RecDropzoneFilesCompressed } from "./types";
import {
  btnUtils,
  makeToast,
  sellingListingValidateImages,
  serializeForm,
} from "./utils";

/**
 * Initializes the listing QR images functionality, including setting up image dropzones and handling form submission.
 * @param {Dropzone[]} dropzoneObjects - An array to store Dropzone instances.
 * @param {RecDropzoneFiles} recDropzoneFiles - An object to store the original files.
 * @param {Object} recDropzoneFilesCompressed - An object to store the compressed files.
 * @param {Object} recDropzonePreloaded - An object to store preloaded files.
 */
export const listingQRImagesInit = async (
  dropzoneObjects: Dropzone[],
  recDropzoneFiles: RecDropzoneFiles,
  recDropzoneFilesCompressed: RecDropzoneFilesCompressed,
  recDropzonePreloaded: Record<string, string>,
) => {
  imageDropzonesInit(
    "#rec-listing-qr-images-form",
    true,
    dropzoneObjects,
    recDropzoneFiles,
    recDropzoneFilesCompressed,
    recDropzonePreloaded,
  );

  const listingQRImagesForm = document.getElementById(
    "rec-listing-qr-images-form",
  ) as HTMLFormElement | null;

  if (listingQRImagesForm) {
    const qrImagesGoButton = document.getElementById(
      "rec-listing-qr-images-go",
    );
    if (qrImagesGoButton) {
      qrImagesGoButton.addEventListener("click", async (e: MouseEvent) => {
        e.preventDefault();
        btnUtils.loadingToggle(e.target as HTMLButtonElement);
        if (sellingListingValidateImages(listingQRImagesForm, 1)) {
          // Package up form data and submit to the same URL but as a post.
          // TODO: reverse-eng this form to generate a better type. This was originally written in JS.
          let formData: Record<string, any> =
            serializeForm(listingQRImagesForm);

          // Check/append images
          document
            .querySelectorAll(".rec-slf-entry .dz-preview")
            .forEach((thisPreviewElem, index) => {
              const thisImageKey =
                thisPreviewElem.getAttribute("data-image-key");
              const thisImageInputName = `listing_image${index + 1}`;
              if (thisImageKey) {
                formData[thisImageInputName] =
                  thisImageKey in recDropzoneFilesCompressed
                    ? recDropzoneFilesCompressed[thisImageKey].dataURL
                    : recDropzoneFiles[thisImageKey].dataURL;
              }
            });

          try {
            const qrImagesPost = await fetch(
              recAppProxyConfig.paths.pathQRListingImages.replace(
                "%sid%",
                formData.session_id,
              ),
              {
                method: "POST",
                body: JSON.stringify(formData),
                headers: { "Content-Type": "application/json" },
              },
            );
            const qrImagesPostResponse = await qrImagesPost.json();
            btnUtils.reset();

            // Upon success, display confirmation screen
            if (!qrImagesPostResponse.errors) {
              const qrImagesConfirm = document.querySelector(
                ".rec-listing-qr-images-confirm",
              );
              const qrImagesEntry = document.querySelector(
                ".rec-listing-qr-images-entry",
              );
              if (qrImagesConfirm && qrImagesEntry) {
                qrImagesConfirm.classList.remove("rec-hidden");
                qrImagesEntry.classList.add("rec-hidden");
              }
            } else {
              makeToast("toast-ajax-error");
            }
          } catch (error) {
            btnUtils.reset();
            makeToast("toast-ajax-error");
          }
        }
      });
    } else {
      console.error("QR Images Go button not found.");
    }
  } else {
    console.error("Listing QR Images Form not found.");
  }
};
